import { api } from './index';

const BASE_PATH = '/api/internal/payment_movements';

export type PaymentMovement = {
  id: number;
  caregiverId: number;
  date: string;
  movementType: string;
  amount: number;
  description: string;
  // In the caregiver's tax bill: its net amount is grossed up with the withholding.
  withTaxBill: boolean;
}

export interface PaymentMovementForm {
  id?: number;
  caregiverId: number;
  date: string;
  movementType: string;
  amount: number;
  description: string;
  withTaxBill: boolean;
}

export const paymentMovementsApi = {
  create(paymentMovementForm: PaymentMovementForm): Promise<PaymentMovement> {
    return api({
      method: 'post',
      url: BASE_PATH,
      data: { paymentMovement: paymentMovementForm },
    }).then(response => response.data.paymentMovement);
  },
  update(paymentMovementForm: Partial<PaymentMovementForm>): Promise<PaymentMovement> {
    return api({
      method: 'put',
      url: `${BASE_PATH}/${paymentMovementForm.id}`,
      data: { paymentMovement: paymentMovementForm },
    }).then(response => response.data.paymentMovement);
  },
  destroy(id: number): Promise<void> {
    return api({
      method: 'delete',
      url: `${BASE_PATH}/${id}`,
    }).then(() => {});
  },
};
